<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>
<script setup>
import { onMounted, onUnmounted,ref } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import Faqinfo from './Faqinfo.json'
import { replaceS3path } from '@/Shared/helper.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import ButtonBack from '@/Shared/Buttons/ButtonBack'
import Icon from '@/Shared/Icons/Icon'
import IconFAQ from '@/Shared/Icons/IconFAQ'
import usePref from '@/Shared/usePref.js'
import TextFor from '@/Shared/Icons/TextFor'

const props = defineProps({
  faq: Object,
  category: String,
  brand: String,
  pref: Object,
})
const filterRef = ref()
const getCategoryInfo = () => {
  const r = Faqinfo.filter((i) => i.slug == props.category)
  return r
}

const faqLoop = () => {
	let r = []
	if( props.brand == 'none') {
		r = props.faq.filter((i) => i.faqCategory == props.category)
	} else {
		r = props.faq.filter((i) => i.faqCategory == props.category && i.faqBrandSlug == props.brand)
	}
  return r
}

const addH2SmallText = () => {
  let r = 'ユーザ様へ'
  if (props.category) {
    let i = getCategoryInfo()
    r = i[0].nameJ
  }
  if (props.brand) {
    r = 'よくある質問'
  }
  return r
}

const addDescriptionText = () => {
  let r = 'ユーザー様からのよくある質問を掲載しています。<br class="hidden xs:block"/>以下から確認したい内容をお選びください。'
  if (props.category) {
    let i = getCategoryInfo()
    r = i[0].description
  }
  if (props.brand && props.brand != 'none') {
    r = `<span class="-indent-2 inline-block">「${getBrandName(props.brand)}」</span>のよくある質問を掲載しています。<br class="hidden xs:block"/>以下から確認したい内容をお選びください。`
  }
  return r
}

const addDescriptionTextNoBrandFAQ = () => {
  const str = getBrandNameJ(props.brand) ? `<span class="-indent-2 inline-block">「${getBrandNameJ(props.brand)}」</span>` : 'このブランド'
  return str + 'についての質問がみつかりませんでした。'
}

const getBrandName = (brand) => {
  const str = brand !== 'all' ? getBrandNameJ(brand) : 'すべてのブランド'
  return str
}

const getBrandNameJ = (brand) => {
  const target = props.pref.brands.filter((item) => item.brandSlug === brand)
  let r = target[0] ? target[0].brandNameLocal : ''
  return r
}

const getBrandThumb = (slug) => {
  let thum = '//img.aandf.co.jp/aandfcojp/img/brands/logo_af_original.svg'
  let r = []
  if (slug != 'all') {
    r = props.pref.brands.filter((i) => i.brandSlug == slug)
    thum = replaceS3path(r[0].brandThumb)
  }
  return thum
}

const openFilter = () => {
  filterRef.value.toggleOpen()
}

onMounted(() => {
	// console.log( props.brand )
	// console.log( faqLoop().length )
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div class="faq">
    <Head title="FAQ" />

    <div class="bg-afgreen lg:min-h-[calc(100vh_-_75px)] xl:min-h-screen lg:grid lg:items-center">
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[80px] md:px-0 md:w-[600px] pb-[60px] sm:pb-[80px] lg:py-[100px]">
        <h2 class="page-title !text-left !pt-[0.8em] sm:!pt-[1em] lg:!pt-0 !pb-[0.3em] text-white">
          <TextFor class="[&_svg]:fill-white" />
          USERS
          <small v-html="addH2SmallText()" />
        </h2>
        <template v-if="faqLoop().length >= 1">
          <p class="text-white mx-auto text-[110%] sm:text-[120%] text-left leading-[1.8] mb-[35px]" v-html="addDescriptionText()" />
        </template>
        <template v-if="props.category == undefined && props.brand == undefined">
          <ul class="[&>li]:relative [&>li]:flex [&>li]:items-center [&>li]:w-full [&>li]:mb-[15px] sm:[&>li]:mb-[20px] [&_a]:!rounded-[15px] [&_a]:!w-full [&_a]:h-[80px] sm:[&_a]:h-[100px] [&_a]:text-[110%] sm:[&_a]:text-[120%] [&_a]:!justify-start [&_a]:pl-[76px] sm:[&_a]:pl-[100px] [&_a]:font-semibold sm:[&_a]:font-medium [&_.af-icon]:scale-[1.3] sm:[&_.af-icon]:scale-[1.4] [&_.af-icon]:right-[6%] sm:[&_.af-icon]:right-[30px] [&_.af-icon]:fill-afgreen">
            <li><IconFAQ type="repair" /><ButtonRounded text="商品の修理について" url="/faq/category/repair" icon="arrow" /></li>
            <li><IconFAQ type="return" /><ButtonRounded text="商品の返品・交換について" url="/faq/category/returnpolicy" icon="arrow" /></li>
            <li><IconFAQ type="shopping" /><ButtonRounded text="商品の購入について" url="/faq/category/shopping" icon="arrow" /></li>
            <li><IconFAQ type="others" /><ButtonRounded text="その他の質問" url="/faq/category/others" icon="arrow" /></li>
            <li><IconFAQ type="mail" /><ButtonRounded text="問い合わせフォーム" url="/contact" icon="arrow" /></li>
          </ul>
        </template>

        <template v-else-if="props.category == undefined && props.brand != undefined">
          <ul v-if="faqLoop().length >= 1">
            <li v-for="each in faq" :key="each" class="outer">
              <Link :href="'/faq/detail/' + each.faqSlug" class="inner">
                <div class="img">
                  <img :src="getBrandThumb(each.faqBrandSlug)" alt="" />
                </div>
                <div class="info">
                  <h3 v-html="getBrandName(each.faqBrandSlug)" />
                  <p>{{ each.faqTitle }}</p>
                </div>
                <Icon type="arrow" />
              </Link>
            </li>
          </ul>
          <template v-else>
            <div class="my-[50px]">
              <p class="text-white text-base leading-8 mb-[30px]" v-html="addDescriptionTextNoBrandFAQ()" />
              <p class="text-white leading-8"><Link href="/faq">以下のBACK</Link>から、弊社取り扱いブランド共通のよくある質問を探すことができます。</p>
            </div>
          </template>

          <Link :href="'/faq/category/' + props.category">
            <ButtonBack color="white" class="back" />
          </Link>
        </template>

        <template v-else>
          <ul v-if="faqLoop().length >= 1">
            <li v-for="each in faqLoop()" :key="each" class="outer">
              
              <Link :href="'/faq/detail/' + each.faqSlug" class="inner">
                <div class="img">
                  <img :src="getBrandThumb(each.faqBrandSlug)" alt="" />
                </div>
                <div class="info">
                  <h3 v-html="getBrandName(each.faqBrandSlug)" />
                  <p>{{ each.faqTitle }}</p>
                </div>
                <Icon type="arrow" />
              </Link>
            </li>
          </ul>
					<template v-else>
	            <div class="my-[50px]">
							<p class="text-white text-base leading-8 mb-[30px]" v-html="addDescriptionTextNoBrandFAQ()" />
							<p class="text-white leading-8"><Link href="/faq">以下のBACK</Link>から、弊社取り扱いブランド共通のよくある質問を探すことができます。</p>
						</div>
					</template>
          <Link :href="'/faq/category/' + props.category">
						<ButtonBack color="white" class="back" />
					</Link>
        </template>
      </div>
    </div>
  </div>
</template>
